import { useState, useCallback, useEffect, useRef, } from "react";
import { Result, config } from "core/utils";
var useSelectedResultIndex = function (result, updateFocus) {
    var _a = useState(0), selectedResultIndex = _a[0], setSelectedResultIndex = _a[1];
    var resultRefs = useRef([]);
    // set focus on input or result item
    useEffect(function () {
        var ref = resultRefs.current[selectedResultIndex];
        if (ref)
            ref.focus();
    }, [selectedResultIndex]);
    // set focus on input when search is opened.
    useEffect(function () {
        if (updateFocus) {
            var ref = resultRefs.current[-1];
            if (ref)
                ref.focus();
        }
    }, [updateFocus]);
    var createKeyPressHandler = useCallback(function (actions) {
        return function (e) {
            if (e.keyCode === config.search.keys.keyUp &&
                selectedResultIndex >= 0) {
                setSelectedResultIndex(selectedResultIndex - 1);
                if (actions.up)
                    actions.up();
            }
            else if (e.keyCode === config.search.keys.keyDown &&
                result &&
                Result.isSuccess(result) &&
                selectedResultIndex < result.value.length - 1) {
                setSelectedResultIndex(selectedResultIndex + 1);
                if (actions.down)
                    actions.down();
            }
            else if (e.keyCode === config.search.keys.escape) {
                if (actions.escape)
                    actions.escape();
            }
        };
    }, [result, selectedResultIndex]);
    return {
        selectedResultIndex: selectedResultIndex,
        setSelectedResultIndex: setSelectedResultIndex,
        createKeyPressHandler: createKeyPressHandler,
        resultRefs: resultRefs,
    };
};
export default useSelectedResultIndex;
